import {createConstants} from "@helpers/utils";


// CONSTANTS
export const constants = createConstants("APP", [
	"SET_STATE",

	// Error modal
	"OPEN_ERROR_MODAL",
	"CLOSE_ERROR_MODAL_START",
	"CLOSE_ERROR_MODAL_END"
]);


// ACTIONS
export const actions = {
	setState: (state) => (dispatch) => {
		dispatch({type: constants.SET_STATE, state});
		return Promise.resolve();
	},

	// Error modal
	openErrorModal: (props) => (dispatch) => {
		dispatch({type: constants.OPEN_ERROR_MODAL, errorModal: {...props, visible: true}});
		return Promise.resolve();
	},
	closeErrorModal: () => (dispatch) => {
		return new Promise(resolve => {
			dispatch({type: constants.CLOSE_ERROR_MODAL_START});
			setTimeout(() => {
				dispatch({type: constants.CLOSE_ERROR_MODAL_END});
				resolve();
			}, 300);
		});
	}
};


const initialState = {
	prevLocation: null,
	session: null,
	partner: null,
	latestViewStates: {},
	fulfilledViewsById: {},
	isAutogiroApproved: false,
	availableBanks: null,
	isProductClassBSelected: false,
	documentsRequired: {},
	attachedDocuments: 0,
	errorModal: {
		visible: false
	}
};

export default (state = initialState, action) => {
	const {type} = action;

	switch (type) {
		case constants.SET_STATE:
			return {...state, ...action.state};

		// Error modal
		case constants.OPEN_ERROR_MODAL:
			return {...state, errorModal: {...state.errorModal, ...action.errorModal}};
		case constants.CLOSE_ERROR_MODAL_START:
			return {...state, errorModal: {...state.errorModal, visible: false}};
		case constants.CLOSE_ERROR_MODAL_END:
			return {...state, errorModal: {visible: false}};

		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/app.js